let $body;

let Modal;
let noun;
let noun_user;
let url_to_array;

if (!window.noun) {
  window.noun = {};
}

noun = window.noun;

$body = require("../helpers/helpers").default.body;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Modal = () => ({
  element: '<div class="modal" data-type="" data-style=""></div>',
  status: void 0,
  authenticate: void 0,
  action: location.href.split("?action="),

  init(modal, attached_element, event_type, on_load, authentication, target) {
    let auth_element;
    let check_auth_and_style;
    let data_elements;
    let loading_modal;
    let markup;
    let modal_element;
    let shown_data_element;
    let url;
    url = `//${url_to_array[2]}/modals/${modal.type}`;
    modal_element = $(`[data-type='${modal.type}']`);
    this.status = "loading";
    $(".modal-overlay").on("click", e => noun.modal.dismiss());
    $(".modal-overlay .inner").on("click", e => e.stopPropagation());
    check_auth_and_style = (
      attached_element,
      modal_element,
      attached_ID,
      element,
    ) => {
      if (noun.modal.authenticate === true) {
        if (attached_element.data("authenticate") === false) {
          modal_element.addClass("visible");
          modal_element.removeClass("hidden");
          if (modal_element.data("style") === "full-blur") {
            $body.addClass("blur");
          }
          this.status = "loading";
          if (on_load !== void 0) {
            on_load(attached_ID);
          }
        } else {
          modal_element = $(".login-signup-modal");
          modal_element.addClass("visible");
          modal_element.removeClass("hidden");
          this.status = "loading";
        }
        console.log(`ELEMENT IS NOW SET AS ${element}`);
        if (element !== void 0) {
          return noun.share_element = $(element);
        }
      } else {
        console.log(`2ELEMENT IS NOW SET AS ${element}`);
        if (element !== void 0) {
          noun.share_element = $(element);
        }
        modal_element.attr("data-type", modal.type);
        modal_element.addClass("visible");
        modal_element.removeClass("hidden");
        if (modal.style === "full-blur") {
          modal_element.attr("data-style", modal.style);
          $body.addClass("blur");
        }
        this.status = "loading";
        if (on_load !== void 0) {
          return on_load(attached_ID);
        }
      }
    };
    attached_element.attr("data-authenticate", modal.authenticate);
    modal_element.attr("data-type", modal.type);
    modal_element.attr("data-style", modal.style);
    switch (modal.type) {
      case "multi-function":
        modal_element.removeClass("hidden");
        data_elements = modal_element.find("[data-show]");
        data_elements.addClass("hidden");
        data_elements.removeClass("visible");
        shown_data_element = $(`[data-show='${modal.data_element}']`);
        shown_data_element.removeClass("hidden");
        shown_data_element.addClass("visible");
    }
    switch (event_type) {
      case "click":
        attached_element.on(event_type, target, function() {
          let action;
          let attached_ID;
          let share_modal;
          attached_ID = $(this).attr("id");
          if (
            $("body#term-detail").length > 0 ||
            $("body#collaborative-collection").length > 0
          ) {
            console.log(
              "term-detail, icon-detail, or collab-collection detail",
            );
            check_auth_and_style(attached_element, modal_element, attached_ID);
          } else {
            check_auth_and_style(
              attached_element,
              modal_element,
              attached_ID,
              this,
            );
          }
          action = `?action=${$("#" + attached_ID).data("action")}`;
          $(".login-signup-modal input[name=next]").val(
            `/${url_to_array[3]}/${url_to_array[4]}/${url_to_array[
              5
            ]}${action}`,
          );
          return share_modal = require("./share_modal");
        });
        break;
      case "interval":
        switch (modal.type) {
          case "loading":
            markup = '<div class="modal loading-modal visible" data-type="loading" data-style=""> <div class="container row"> <div class="loading clearfix"> <div class="dot dot1"></div> <div class="dot dot2"></div> <div class="dot dot3"></div> <div class="dot dot4"></div> </div> </div> </div>';
            attached_element.append(markup);
            loading_modal = $(".loading-modal");
            loading_modal.attr("data-style", modal.style);
            $("body").addClass("blur");
        }
        break;
      case "auto-initialize":
        check_auth_and_style(attached_element, modal_element);
    }
    if (noun.modal.action[1] !== void 0) {
      if (attached_element.data("authenticate") === true) {
        if (noun_user.is_anonymous === false) {
          modal.type = "download";
        } else {
          modal.type = "login-signup";
        }
        modal_element = $(`.modal.${modal.type}-modal`);
        modal_element.removeClass("hidden");
        check_auth_and_style(void 0, modal_element);
        noun.modal.action[1] = void 0;
        console.log(noun.modal.action);
      }
    }
    if (noun_user.is_anonymous === true) {
      if (noun.modal.authenticate === void 0) {
        modal.type = "login-signup";
        modal.style = "full-black";
        console.log(url);
        auth_element = $(`.modal.${modal.type}-modal`);
        this.status = "loading";
        noun.modal.authenticate = true;
        this.status = "loaded";
        auth_element.attr("data-type", modal.type);
        return auth_element.attr("data-style", modal.style);
      }
    }
  },

  dismiss() {
    let base;
    let modal_element;
    modal_element = $(".modal");
    modal_element.addClass("hidden");
    modal_element.removeClass("visible");
    $("body").removeClass("blur");
    if (typeof (base = noun.modal).reset_download === "function") {
      base.reset_download();
    }
    if ($("#information-modal").length > 0) {
      $("#information-modal").removeClass("visible");
      return setTimeout(() => $("#information-modal").remove(), 100);
    }
  },
});

noun.modal = Modal();

export default Modal();
